import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { InferRequestType, InferResponseType } from 'hono/client'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

type CreateAttributeGroupRequest = InferRequestType<
  (typeof apiClient)['attribute-groups']['$post']
>['json']
type CreateAttributeGroupResponse = InferResponseType<
  (typeof apiClient)['attribute-groups']['$post']
>

export type UseCreateAttributeGroupArgs = CreateAttributeGroupRequest

export const useCreateAttributeGroup = (
  options?: UseMutationOptions<
    CreateAttributeGroupResponse,
    Error,
    UseCreateAttributeGroupArgs
  >
) =>
  useMutation({
    mutationFn: async (variables) => {
      return await apiClient['attribute-groups']
        .$post({ json: variables })
        .then((r) => formatClientResponse(r))
    },
    mutationKey: ['attribute-group-create'],
    ...options,
  })
